import './login.css';
import { useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { agentSignin } from '../../../features/authentication/AuthenticationSlice';
import Loading from '../../../Loading';
import logo from "../../../assets/media/image/KAVIR-RGB.png";
import logoB from "../../../assets/media/image/WWW-RGB.jpg";

function Login (props) {

    const navigate = useNavigate()
    const [mobile, setMobile] = useState('')
    const [password, setPassword] = useState('')
    let [check, setCheck] = useState(false)
    const token = localStorage.getItem('token')
    const account = {
        'mobile': mobile,
        'password': password
    }

    const dispatch = useDispatch()
    const user = useSelector(state => state.authentication.user)
    const loading = useSelector(state => state.authentication.loading)
    const error = useSelector(state => state.authentication.error)
    const mobileError = useSelector(state => state.authentication.mobileError)
    const passwordError = useSelector(state => state.authentication.passwordError)
    const redirectFlag = useSelector(state => state.authentication.redirectFlag)

    const loginHandler = (event) => {
        event.preventDefault();
        dispatch(agentSignin(account))
    }
    useEffect (() => {
        if( redirectFlag == true) {
             navigate('/agent') 
        }


    },[redirectFlag])
    useEffect (() => {

        if(token ){
            const {role} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []
            if(role && role == '1'){
                navigate('/dashboard')
            }else if(role && role == '2'){
                navigate('/agent')
            }else if(role && role == '3'){
                navigate('/exhibition')
            }else{
                localStorage.removeItem('token')
            }

            
        }else{
            localStorage.removeItem('token')
        }
      

    },[])

    return (
        <div className="row vh-100 p-0 m-0 rahpardaznet-back-color">
            {loading ? (<Loading />) : ''}

            <div className="col-12  d-flex flex-column justify-content-center align-items-center">
                <img src={logo} alt="کویر موتور"  className='rahpardaznet-logo-kavir'/>
                <img src={logoB} alt="کویر موتور"  className='rahpardaznet-logo-bottom-kavir'/>

                <div className='rahpardaznet-browser-details'></div>
                <div className="col-12 col-md-4 z-index-1">
                    <form onSubmit={loginHandler} className="rahpardaznet-login">
                        <div className="rahpardaznet-form-title mt-4 mb-5">سامانه جامع  نمایندگان کویر موتور</div>
                        <div className='mb-3 input'>
                            <input
                                type='text'
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                className="form-control form-control-lg shadow-none"
                                id='exampleInputMobile'
                                aria-describedby='mobileHelp'
                                placeholder='تلفن همراه خود را وارد کنید'
                            />
                            {
                                (mobileError) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger'>{mobileError}</small>
                                    </span>
                                ) : ''}
                        </div>
                        <div className=' mb-3 input'>
                            <input
                                type='password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-control form-control-lg shadow-none"
                                id='exampleInputPassword'
                                aria-describedby='passwordHelp'
                                placeholder='گذروازه خود را وارد کنید'
                            />
                            {
                                (passwordError) ? (
                                    <span className="help-block  fw-bold d-inline-block mt-2 has-error">
                                        <small className='text-danger'>{passwordError}</small>
                                    </span>
                                ) : ''}
                        </div>

                        <button
                            type="submit"
                            className="me-auto px-4 py-2 btn btn-primary  mb-4">
                          
                            {
                                (loading) ? (
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                ) : 'ناحیه کاربری '
                            }
                        </button>
                        {
                            (user) ? (
                                error
                            ) : ''
                        }

                    </form>
                </div>
            </div>


        </div>
    )
}

export default Login;